import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const RespondToInquiryModal = ({ inquiry, players, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    playerId: '',
    proposedTerms: '',
    askingPrice: '',
    availabilityDate: '',
    additionalNotes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit({ ...formData, inquiryId: inquiry?.id });
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-lg shadow-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">Respond to Inquiry</h2>
            <p className="text-sm text-muted-foreground mt-1">{inquiry?.title}</p>
          </div>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Select Player *</label>
            <Select
              value={formData?.playerId}
              onChange={(value) => handleSelectChange('playerId', value)}
              options={[
                { value: '', label: 'Choose a player...' },
                ...(players?.map(player => ({
                  value: player?.id,
                  label: `${player?.fullName} - ${player?.primaryPosition} (€${player?.currentMarketValue}M)`
                })) || [])
              ]}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Proposed Terms *</label>
            <textarea
              name="proposedTerms"
              value={formData?.proposedTerms}
              onChange={handleChange}
              placeholder="e.g., 4-year contract with performance bonuses. Player available for immediate transfer pending medical."
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              rows={3}
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Asking Price (€M) *</label>
              <Input
                type="number"
                name="askingPrice"
                value={formData?.askingPrice}
                onChange={handleChange}
                placeholder="e.g., 55"
                step="0.1"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Availability Date</label>
              <Input
                type="date"
                name="availabilityDate"
                value={formData?.availabilityDate}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Additional Notes</label>
            <textarea
              name="additionalNotes"
              value={formData?.additionalNotes}
              onChange={handleChange}
              placeholder="Any additional information about the player or terms..."
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              rows={3}
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button type="button" variant="outline" onClick={onClose} fullWidth>
              Cancel
            </Button>
            <Button type="submit" variant="default" fullWidth disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Response'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RespondToInquiryModal;